import React from "react";
import { UserIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import CustomUnloginMenu from "./customUnloginMenu";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const CustomMenu = ({ addresses }) => {
  const { t } = useTranslation();

  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const iconSize = isMobile
    ? "lg:w-6 w-5 lg:h-6 h-5"
    : "lg:w-6 w-5 lg:h-6 h-5 ";
  const navigateWithLang = useLanguageNavigate();

  // Check if accessToken exists in localStorage
  const accessToken = localStorage.getItem("accessToken");

  const direction = useLanguageDirection();

  return (
    <div
      className="relative flex justify-center gap-5 "
      style={{ marginLeft: 0 }}
    >
      <Menu>
        <MenuButton
          className="flex items-center justify-center group"
          dir="ltr"
          onClick={(e) => {
            if (!accessToken) {
              e.preventDefault();
              navigateWithLang("/login");
            }
          }}
        >
          {/* Display username (kordy) if accessToken exists */}
          {accessToken ? (
            <div className="flex flex-row items-center" dir={direction}>
              <UserIcon
                className={`${iconSize} text-white duration-300 group-hover:text-custom-yellow `}
              />
              <span className="hidden mx-1 text-sm text-white duration-300 md:block group-hover:text-custom-yellow">
                {addresses?.user?.firstName}
              </span>
              <span>
                <ChevronDownIcon className="w-4 h-4 text-white duration-300 ms-1 group-hover:text-custom-yellow" />
              </span>
            </div>
          ) : (
            <span className="flex items-center" dir={direction}>
              <UserIcon
                className={`${iconSize}  text-white duration-300 group-hover:bg-transparent group-hover:text-custom-yellow  rounded-full`}
              />
              <span className="hidden mx-1 text-sm text-white duration-300 md:block group-hover:text-custom-yellow">
                {t("login")}
              </span>
            </span>
          )}
        </MenuButton>
        <MenuItems className="absolute z-[9999999999999] text-black bg-white mt-10 rounded-[3px] shadow-lg start-0 w-56 md:w-80">
          {accessToken && (
            <>
              <div
                className={`absolute w-0 h-0 border-b-8 border-l-8 border-r-8 ${
                  direction === "ltr" ? "right-10" : "left-10"
                }  -top-2 border-l-transparent border-r-transparent border-b-white`}
              ></div>
            </>
          )}

          <CustomUnloginMenu
            accessToken={accessToken}
            role={addresses?.user?.role}
          />
        </MenuItems>
      </Menu>
    </div>
  );
};

export default CustomMenu;
